export default class VideoOverlay {
    constructor(element) {
        this.overlay = element
        this.video = this.overlay.getElementsByTagName('iframe')
        this.overlay.addEventListener('click', () => this.toggle())
    }

    toggle() {
        this.overlay.classList.toggle('play')
    }
}